import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  getBackSeatUrl,
  getCenterConsoleUrl,
  getInteriorStatus,
} from '../../store/car-slice';

import { Loading } from '../../components';

import Zoom from '../../components/zoom/zoom';

import { Box, useMediaQuery } from '@mui/material';
import Buttons from '../buttons/buttons';

export default function Camera() {
  // Selectors

  const centerConsoleUrl = useSelector(getCenterConsoleUrl);
  const backSeatUrl = useSelector(getBackSeatUrl);

  const interiorStatus = useSelector(getInteriorStatus);

  const isPortrait = useMediaQuery('(orientation: portrait)');

  // States
  const [loading, setLoading] = React.useState(true);

  const interiorImage = useMemo(() => {
    if (interiorStatus === 'center-console') {
      return centerConsoleUrl;
    }

    if (interiorStatus === 'back-seat') {
      return backSeatUrl;
    }
  }, [interiorStatus, centerConsoleUrl, backSeatUrl]);

  const loadingMessage = `Loading your ${
    interiorStatus === 'center-console' ? 'Center Console' : 'Back Seat'
  } image`;

  React.useEffect(() => {
    setLoading(true);
  }, [interiorStatus, centerConsoleUrl, backSeatUrl]);

  React.useEffect(() => {
    setLoading(true);
  }, []);

  if (interiorImage) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          transition: 'all 0.3s ease-in-out',
        }}
      >
        <Box sx={{ position: 'relative' }}></Box>
        {loading ? <Loading loadingMessage={loadingMessage} /> : null}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
          }}
        >
          <Zoom initialScale={1.5} section="interior">
            <img
              alt="interior"
              loading="lazy"
              onLoad={() => setLoading(false)}
              src={interiorImage}
            />
          </Zoom>

          {isPortrait && <Buttons />}
        </Box>
      </Box>
    );
  } else return null;
}
